import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { followUpQKeys } from "@hooks/queries/followUp/queryKeys";
import { patientNoteQKeys } from "@hooks/queries/patientNote/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  followUpId?: string;
  reason?: string;
  followUpDate?: Date;
  intent: "close" | "update";
  patientId?: string;
}

export const useUpdateFollowUp = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({
      intent,
      followUpId,
      reason,
      followUpDate,
      patientId,
    }: MutationProps) => {
      if (intent === "close") {
        return api.patch(`follow-up/${followUpId}/close`, {
          reason,
        });
      } else {
        return api.patch(`follow-up/${followUpId}`, {
          reason,
          follow_up_date: followUpDate?.toISOString(),
        });
      }
    },
    onSuccess: (res, variables) => {
      queryClient.invalidateQueries({
        queryKey: followUpQKeys.all(),
      });

      if (variables?.patientId) {
        queryClient.invalidateQueries({
          queryKey: patientNoteQKeys.allWithFilters({
            patientId: variables.patientId,
          }),
        });
      }
    },

    onError: (res: any) => {
      console.error("[From Update Follow Up]", res);
      handleErrors(res, "mutation");
    },
  });
};
